//
//
//
//

import {formatDimension} from "../../helpers/format_helpers";
import Roundable from "../../mixins/Roundable";

export default {
    name: "Skeleton",

    mixins: [Roundable],

    props: {

        rounded: {
            type: Boolean,
            default: false
        },

        // The fixed width of the skeleton in pixels; when 'null', a random width between minWidth and maxWidth will be calculated
        width: {
            default: null,
            type: [String, Number],
        },

        // The min width of the skeleton in pixels
        minWidth: {
            type: [Number,String],
            default: 60
        },

        // The max width of the skeleton in pixels
        maxWidth: {
            type: [Number,String],
            default: 100
        },

        // The height of the skeleton
        // Defaults to the height of a paragraph
        height: {
            default: '16px',
            type: [String, Number],

        },
    },

    computed: {
        computedWidth() {
            return this.width ? formatDimension(this.width) : `${Math.floor((Math.random() * (parseFloat(this.maxWidth) - parseFloat(this.minWidth))) + parseFloat(this.minWidth))}px`;
        },

        computedHeight() {
            return formatDimension(this.height);
        }
    },
}
